import { render, staticRenderFns } from "./b_Security.vue?vue&type=template&id=4328d010&scoped=true&"
import script from "./b_Security.vue?vue&type=script&lang=js&"
export * from "./b_Security.vue?vue&type=script&lang=js&"
import style0 from "./b_Security.vue?vue&type=style&index=0&id=4328d010&prod&lang=css&"
import style1 from "./b_Security.vue?vue&type=style&index=1&id=4328d010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4328d010",
  null
  
)

export default component.exports